import React from 'react';
type Props = {
  children?: React.ReactNode;
};
const ErrorComponent: React.FC<Props> = ({ children }) => {
  return <div>ErrorComponent</div>;
};

export default ErrorComponent;
